import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";
import { runAction } from "../services/actionService";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default class UtilPDF{

    static downloadPDFFromAction = async (params) => {

        const getBase64FromUrl = async (url) => {
            const data = await fetch(url);
            const blob = await data.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob); 
                reader.onloadend = () => {
                const base64data = reader.result;   
                resolve(base64data);
                //console.log('base64data: ', base64data)
                }
            });
        };

        let pdfResponse = await runAction({name: params.actionName },{
            ...params.params
        });

        if(pdfResponse?.data?.content[0]?.image){
            const url = pdfResponse?.data?.content[0]?.image;
            const url64 = await getBase64FromUrl(url?.toString())
            pdfResponse.data.content[0].image = url64
        }

        if(pdfResponse.footer){
            let columns = pdfResponse.footer;
            // console.log("COLUMNS >>> ", columns)

            pdfResponse.data.footer = function(currentPage, pageCount) { //currentPage, pageCount
                // this.result.currentPage = currentPage
                // this.result.pageCount = pageCount

                return columns;

            }
        }

        if(pdfResponse.header){
            pdfResponse.data.header = pdfResponse.header;
        }

        console.log(pdfResponse);

        pdfMake.createPdf(pdfResponse.data).download(params.documentName);

        // console.log(pdfPronto);

    }

}